import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Category } from 'src/app/model/category';
import { AppModeService } from 'src/app/services/app-mode.service';
import { HomeService } from '../home/services/home.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css'],
})
export class CategoriesComponent {
  categories: Category[] = [];
  imageUrl = environment.apiUrl;

  constructor(
    private readonly homeService: HomeService,
    private readonly router: Router,
    public readonly appModeService: AppModeService,
  ) {
    // Log the current mode for debugging
  }

  ngOnInit(): void {
    // HomeService automatically handles app/web endpoint selection
    this.homeService.getCategories().subscribe((res) => {
      this.categories = res || [];
    });
  }

  goBack(): void {
    const lang = localStorage.getItem('lang') || 'en';
    this.router.navigateByUrl(`/${lang}/home`);
  }

  /**
   * Navigate to products filtered by category
   */
  goToProductsByCategory(categoryName: string): void {
    this.router.navigate(['/products'], {
      queryParams: { category: categoryName },
    });
  }

  /**
   * TrackBy function for category list rendering optimization
   */
  trackByCategory(_: number, category: Category): string {
    return category.id || category.name;
  }

  /**
   * Get category image with fallback
   */
  getCategoryImage(category: Category): string {
    return category.imageUrl
      ? this.imageUrl + category.imageUrl
      : 'assets/img/jersey.png';
  }
}
